import React from 'react';
import styles from './Tooltip.module.css';

const Tooltip = ({
  content,
  children,
  position = 'top',
  className = '',
  tooltipClassName = '',
  disabled = false,
  style,
  mt, mb, ml, mr,
  ...rest
}) => {

  if (disabled || !content) {
    return <>{children}</>;
  }
  
  const wrapperStyle = { ...style };
  const getSpacingValue = (v) => typeof v === 'number' ? `calc(var(--cipher-spacing-unit) * ${v})` : v;
  if (mt !== undefined) wrapperStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) wrapperStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) wrapperStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) wrapperStyle.marginRight = getSpacingValue(mr);

  return (
    <span
      className={`${styles.tooltipWrapper} ${className}`}
      style={wrapperStyle}
      {...rest}
    >
      {children}
      <span
        className={`${styles.tooltipText} ${styles[position]} ${tooltipClassName}`}
        role="tooltip"
      >
        {content}
      </span>
    </span>
  );
};

export default Tooltip;